import React from 'react';
import { Wallet } from 'lucide-react';
import DevFundBalance from './DevFundBalance';
import ContributionsList from './ContributionsList';

export default function DevFundSection() {
  return (
    <section id="devfund" className="relative py-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(#1e293b_1px,transparent_1px)] [background-size:16px_16px] opacity-50" />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/95 via-slate-900/98 to-slate-900/95" />
      
      {/* Accent Lines */}
      <div className="absolute inset-0">
        <div className="h-px w-full bg-gradient-to-r from-transparent via-green-500/20 to-transparent" />
        <div className="absolute bottom-0 h-px w-full bg-gradient-to-r from-transparent via-green-500/20 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-6">
              <Wallet className="h-10 w-10 text-green-500" />
              <h2 className="text-4xl font-bold">Developer Fund</h2>
            </div>
            <p className="text-gray-400 max-w-2xl mx-auto">
              The TWINS Developer Fund receives 10% of block rewards to support ongoing development, 
              marketing, and ecosystem growth. All transactions are transparent and recorded on-chain.
            </p>
          </div>

          <div className="space-y-12">
            <DevFundBalance />
            <ContributionsList />
          </div>
        </div>
      </div>
    </section>
  );
} 